export const isMobile = () => isMobileDevice();

export const getOrSetDefault_Aside_isVisible = (state) => {
  if (typeof localStorage != undefined && typeof localStorage != 'undefined') {
    if (typeof state != 'undefined') {
      localStorage.setItem('aside_isVisible', state);
    } else {
      const ls_aside_isVisible = localStorage.getItem('aside_isVisible');

      if (!ls_aside_isVisible) {
        const value = isMobileDevice() ? false : true;
        localStorage.setItem('aside_isVisible', value);
      }
      return ls_aside_isVisible != null ? ls_aside_isVisible == 'true' : null;
    }
  }

  return false;
};

export const updatePageData = async (key, value) => {
  if (key === 'aside_isVisible') {
    localStorage.setItem('aside_isVisible', value);
  }
};

export default {
  isMobile,
  getOrSetDefault_Aside_isVisible,
  updatePageData,
};

function isMobileDevice() {
  return typeof window !== 'undefined' && window.innerWidth < 768;
}
